import { defineComponent as _defineComponent } from 'vue';
import { ref } from "vue";
import ActivitySettings from "@/components/ActivityBar/ActivitySettings.vue";
import DelayedInput from "@/components/Common/DelayedInput.vue";
import ActivityPanel from "@/components/Panels/ActivityPanel.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'SettingsPanel',
    setup(__props) {
        const query = ref("");
        function onQuery(newQuery) {
            query.value = newQuery;
        }
        return { __sfc: true, query, onQuery, ActivitySettings, DelayedInput, ActivityPanel };
    }
});
